import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/components/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section about">
            <h3>Wings, Burgers, & More</h3>
            <p>We serve delicious wings, burgers, and twists on classic American cuisine. Enjoy our craft beer selection while dining in or take out for a quick meal.</p>
          </div>
          
          <div className="footer-section locations">
            <h3>Locations</h3>
            <div className="location-item">
              <h4>Katy Location</h4>
              <p>3325 West Grand Parkway North Ste. B</p>
              <p>Katy, TX</p>
              <p><a href="mailto:info@texascraftwings.com">info@texascraftwings.com</a></p>
            </div>
            
            <div className="location-item">
              <h4>Lake Conroe Location</h4>
              <p>11525 FM 1097, Willis, TX</p>
              <p><a href="tel:9368568929">(936) 856-8929</a></p>
              <p><a href="mailto:info@texascraftwings.com">info@texascraftwings.com</a></p>
              <p>Sun-Mon: 11am-12am</p>
              <p>Tues: 11am-12am</p>
              <p>Wed-Thurs: 11am-12am</p>
              <p>Fri-Sat: 11am-2am</p>
            </div>
          </div>
          
          <div className="footer-section links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/menu">Menu</Link></li>
              <li><Link to="/locations">Locations</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><a href="https://order.toasttab.com/online/texas-craft-wings-lake-conroe" target="_blank" rel="noopener noreferrer">Order Online</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Texas Craft Wings. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
